import React from 'react';
import { cn } from '../../lib/theme';

const Card = ({ children, className, ...props }) => {
  return (
    <div
      className={cn(
        'rounded-xl border shadow-sm',
        'bg-white dark:bg-gray-800',
        'border-gray-200 dark:border-gray-700',
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};

const CardHeader = ({ children, className }) => (
  <div className={cn('p-6 border-b border-gray-200 dark:border-gray-700', className)}>
    {children}
  </div>
);

const CardContent = ({ children, className }) => (
  <div className={cn('p-6', className)}>
    {children}
  </div>
);

const CardFooter = ({ children, className }) => (
  <div className={cn('p-6 border-t border-gray-200 dark:border-gray-700', className)}>
    {children}
  </div>
);

export { Card, CardHeader, CardContent, CardFooter };
